import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";
import Icon from "./icon";
import { Link } from "./link";
import withPreview from "../utility/with-preview";
import monogram from "../images/monogram-blog.svg";
import { useTranslation } from "react-i18next";
import { formatDate } from "../utility/print-date";
import { useTranslateCategory } from "../utility/category-translation";

const Blog = ({
  data: { title, publishingDate, category, tags, link, image },
  loading = "lazy",
}) => {
  const { t } = useTranslation();
  const translateCategory = useTranslateCategory();
  return (
    <article className={classNames("blog", { "blog--white": !image })}>
      <div className="blog__background blog__background--image">
        {image && (
          <GatsbyImage image={getImage(image)} alt={title} objectFit="cover" loading={loading} />
        )}
      </div>
      <div className="blog__background blog__background--overlay"></div>
      <img
        className="blog__background blog__background--monogram"
        src={monogram}
        alt="Sisvel monogram"
      />
      <Link
        to={`/insights/?category=${encodeURIComponent(translateCategory(category, "blog"))}`}
        className="blog__category ms-auto"
      >
        {translateCategory(category, "blog")}
      </Link>
      {publishingDate && <div className="blog__date ms-auto">{formatDate(publishingDate)}</div>}
      <div className="blog__tags mt-auto">
        {tags?.map((tag, index) => (
          <Link to={`/insights/?tag=${tag}`} key={index}>{`#${tag}`}</Link>
        ))}
      </div>
      <h3 className="blog__title">{title}</h3>
      <Link to={link} className="blog__read-more ms-auto">
        {t("readMore")} <Icon name="arrow-right" width={14} height={14} />
      </Link>
    </article>
  );
};

export default withPreview(Blog);
